/* gk-promo-combo */
if (!customElements.get('gk-promo-combo')) {
  class GkPromoCombo extends HTMLElement {
    connectedCallback() {
      this.hEl = this.querySelector('[data-gkpc-h]');
      this.mEl = this.querySelector('[data-gkpc-m]');
      this.sEl = this.querySelector('[data-gkpc-s]');
      this.barFill = this.querySelector('[data-gkpc-bar]');

      this.target = this.calcNextMidnight();
      this.dayMs = 24 * 60 * 60 * 1000;

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    calcNextMidnight() {
      const now = new Date();
      const next = new Date(now);
      next.setHours(24, 0, 0, 0);
      return next.getTime();
    }

    tick() {
      const now = Date.now();
      let diff = this.target - now;

      if (diff <= 0) {
        this.target = this.calcNextMidnight();
        diff = this.target - now;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const h = Math.floor(totalSeconds / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = totalSeconds % 60;

      if (this.hEl) this.hEl.textContent = this.pad(h);
      if (this.mEl) this.mEl.textContent = this.pad(m);
      if (this.sEl) this.sEl.textContent = this.pad(s);

      if (this.barFill) {
        // Quanto MAIOR a porcentagem, mais perto da meia-noite (oferta acabando)
        const pct = 100 - (diff / this.dayMs) * 100;
        this.barFill.style.width = Math.max(0, Math.min(100, pct)) + '%';
      }
    }

    pad(n) {
      return String(n).padStart(2, '0');
    }
  }
  customElements.define('gk-promo-combo', GkPromoCombo);
}
